export default __webpack_public_path__ + "static/web-experience-56d37672141a69bcc4ca11f10b5944b0.png";